
/**
 * Generates a reference number using an abbreviation and a timestamp.
 * Format: PREFIX + YYYYMMDDHHmmss
 * Example: ASN20260126153012
 * 
 * @param prefix The abbreviation prefix (e.g., 'ASN', 'INV')
 * @returns The generated reference number
 */
export function generateReferenceNumber(prefix: string): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  
  const timestamp = `${year}${month}${day}${hours}${minutes}${seconds}`;
  
  return `${prefix}${timestamp}`;
}
